import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=8903034a&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=8903034a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8903034a",
  null
  
)

export default component.exports